import script from "./LeaderPortfolios.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderPortfolios.vue?vue&type=script&setup=true&lang=js"

import "./LeaderPortfolios.vue?vue&type=style&index=0&id=372a3932&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-372a3932"]])

export default __exports__